import { RotateCw } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface RefreshButtonProps {
  onClick: () => void;
  /** Gira el icono mientras se recargan los datos. */
  spinning?: boolean;
}

/** Botón para volver a pedir los datos de la pantalla actual del backoffice. */
export function RefreshButton({ onClick, spinning = false }: RefreshButtonProps) {
  const { t } = useTranslation();
  return (
    <button
      onClick={onClick}
      disabled={spinning}
      title={t('common.refresh')}
      aria-label={t('common.refresh')}
      className="inline-flex items-center gap-1.5 rounded-md border border-stone-300 bg-white px-3 py-1.5 text-sm text-stone-600 transition-colors hover:bg-stone-50 disabled:opacity-60"
    >
      <RotateCw size={15} className={spinning ? 'animate-spin' : undefined} />
      <span className="hidden sm:inline">{t('common.refresh')}</span>
    </button>
  );
}
